namespace RioERP.Enquiry {
    @Serenity.Decorators.registerClass()
    export class EnquiryGrid extends Serenity.EntityGrid<EnquiryRow, any> {
        protected getColumnsKey() { return EnquiryColumns.columnsKey; }
        protected getDialogType() { return EnquiryDialog; }
        protected getIdProperty() { return EnquiryRow.idProperty; }
        protected getInsertPermission() { return EnquiryRow.insertPermission; }
        protected getLocalTextPrefix() { return EnquiryRow.localTextPrefix; }
        protected getService() { return EnquiryService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }
        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: EnquiryService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            return buttons;
        }

        /*protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {
            let filters = super.getQuickFilters();

            Q.first(filters, x => x.field == EnquiryRow.Fields.HandledBy).init = w => {
                (w as Serenity.LookupEditor).items[0].id;
            }
            return filters;
        }*/

        protected getItemCssClass(item: Enquiry.EnquiryRow, index: number): string {
            let klass: string = "";

            if (item.EStatus == RioERP.Web.Enums.EnquiryStatus.followUpRequired)
                klass += " followUpRequired";

            else if (item.EStatus == RioERP.Web.Enums.EnquiryStatus.newenquiry)
                klass += " newenquiry";
            else if (item.EStatus == RioERP.Web.Enums.EnquiryStatus.closed)
                klass += " closed";
            else if (item.EStatus == RioERP.Web.Enums.EnquiryStatus.notinterested)
                klass += " notinterested";
            else if (item.EStatus == RioERP.Web.Enums.EnquiryStatus.notResponding)
                klass += " notResponding";
            else if (item.EStatus == RioERP.Web.Enums.EnquiryStatus.callBack)
            klass += " callBack";

            return Q.trimToNull(klass);
        }
    }
}